module.exports = __webpack_public_path__ + "img/apply-for-invoicing.6f391596.png";